import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <section className="policy-page">
      
      <div className="container">

        <div className="policy-header">
          <h1>Privacy Policy</h1>
          <p>
            Effective Date: August 2, 2026
          </p>
        </div>

        <div className="policy-content">

          <section>
            <h2>1. Introduction</h2>
            <p>
              Swanora Global ("Company", "we", "our", or "us") respects your
              privacy and is committed to protecting the personal information
              you share with us. This Privacy Policy explains how we collect,
              use, store, and protect your information when you use our
              website or contact us regarding our import and export services.
            </p>
          </section>

          <section>
            <h2>2. Information We Collect</h2>

            <h3>Personal Information</h3>

            <ul>
              <li>Full Name</li>
              <li>Email Address</li>
              <li>Phone Number</li>
              <li>Company Name</li>
              <li>Country</li>
              <li>Business Inquiry Details</li>
            </ul>

            <h3>Technical Information</h3>

            <ul>
              <li>IP Address</li>
              <li>Browser Information</li>
              <li>Operating System</li>
              <li>Pages Visited</li>
              <li>Device Information</li>
            </ul>

          </section>

          <section>
            <h2>3. How We Use Your Information</h2>

            <ul>
              <li>Respond to inquiries.</li>
              <li>Provide quotations.</li>
              <li>Process export requests.</li>
              <li>Improve our website.</li>
              <li>Maintain business communication.</li>
              <li>Meet legal obligations.</li>
            </ul>

          </section>

          <section>
            <h2>4. Cookies</h2>

            <p>
              We may use cookies and similar technologies to improve website
              functionality, analyze visitor activity, and enhance user
              experience.
            </p>

          </section>

          <section>
            <h2>5. Information Sharing</h2>

            <p>
              We never sell your personal information. Information may only be
              shared with logistics providers, customs authorities, payment
              partners, IT service providers, or government authorities when
              legally required.
            </p>

          </section>

          <section>
            <h2>6. Data Security</h2>

            <p>
              We implement appropriate technical and organizational measures to
              protect your information against unauthorized access, misuse, or
              disclosure.
            </p>

          </section>

          <section>
            <h2>7. Data Retention</h2>

            <p>
              Personal information is retained only as long as necessary for
              business, legal, and regulatory purposes.
            </p>

          </section>

          <section>
            <h2>8. Your Rights</h2>

            <ul>
              <li>Access your data.</li>
              <li>Correct inaccurate information.</li>
              <li>Request deletion where applicable.</li>
              <li>Withdraw consent where legally permitted.</li>
            </ul>

          </section>

          <section>
            <h2>9. Contact Us</h2>

            <p><strong>Swanora Global</strong></p>
            <p>Email: info@swanoraglobal.com</p>
            <p>Surat, Gujarat, India</p>

          </section>

        </div>

      </div>
    </section>

  );
};

export default PrivacyPolicy;